import type { FaireProductEntity } from "../../entity_types/product";

export const p_ybnjdgeuqa: FaireProductEntity = {
  token: "p_ybnjdgeuqa",
  type: "product",
  name: "Blair Waxed Cotton Jacket - (2XS/S - 2M/L)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/662e300f287d41794c571ba31005e9156567a991847a8db6dc0292f736a4a2e5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7bbf5df72aee6e00f736a23e20c2298cd4e0c4b5299580ee2cfa7284e94a5a54.jpeg",
    "https://cdn.faire.com/fastly/1a60b0b108066b70d53e80d7122cc384823c37b2352df84050393f87e4497bc3.jpeg",
    "https://cdn.faire.com/fastly/128fd1624a9f7f1dcd2d440aed3ab6b8698ac50a03595dc8672a2de886193597.jpeg",
    "https://cdn.faire.com/fastly/7ec4c6c731ee17a88044de01d4444aad3f17a7a08e04e29085ac585c2b4e9638.jpeg",
    "https://cdn.faire.com/fastly/2b9f40860c6ab5820c9b575d08a824975e35776123583f1139b82a5897451427.jpeg",
    "https://cdn.faire.com/fastly/f882ab5b47f898adc80dca4b359e8b1f832f915875f4d6f491d8544e95f4de54.jpeg",
    "https://cdn.faire.com/fastly/724e861271cacd26d8f1a565179dd1fb4fc0247b84539dee879198489432c89a.jpeg",
    "https://cdn.faire.com/fastly/61a81b7537ea0eabfd778b78d4b768abd4938a1f1c65b25980e00939edef5938.jpeg",
    "https://cdn.faire.com/fastly/88fb374f045e02838e14870a0faf7d749c99c9b0e4963f64c218f4c855c4ba1a.jpeg",
  ],
  priceDollars: 360,
  description:
    'Why we made this?\n\nRain or shine, the Blaire fits a niche need in any wardrobe. Made from durable waxed cotton, it’s built to take on light, wet weather with a modern silhouette that features a high funnel neck, roomy barrel sleeves, and a secure zip-and-button front. It’s the kind of piece that ages beautifully, developing a unique character with every wear. Finished with deep front pockets and a cheeky interior loop for keys or trinkets, it is the perfect blend of practical and playful.\n\n\n\n\nContents: \n\n100% Cotton\n100% Polyester lining\n\nMade in China\n\n\n\nCare Instructions:\n\nDo not dry clean\n\nDo not machine wash or tumble dry\n\nDo not steam or iron\n\nBrush off dirt when dry and sponge the area with cold water only\n\nNever use soap or detergents\n\n\n\nApproximate Measurements: \n\nXS/S - Length: 28", Chest: 25 1/2"\n\nM/L - Length: 29", Chest: 27" \n\n\n\n\nModel is 5\' 6", Bust: 34", Waist: 27", Hip:36" and wearing a size XS/S \n\n\n\nMSRP: $195 USD\n',
  tags: [],
  msrpDollars: 720,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:52:00.970Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
